import { Box, Center, Container, Heading, Link, Text, VStack } from "@chakra-ui/react";
import { parseEther } from "ethers/lib/utils";
import { useState } from "react";
import { useAccount, useNetwork } from "wagmi";

import WalletNetwork from "./WalletNetwork";
import { useSupportedNetwork } from "../helpers/hooks/network";
import DcaConfig from "../components/dca/DcaConfig";
import DcaInfo from "../components/dca/DcaInfo";
import analyticsInstance from "../config/analytics";

const BetaBanner = () => {
  return (
    <Box my="2.5em" py="0.5em" bgColor="#ffdead" w="full" color="#280000" fontWeight="bold" align="center">
      <Text fontSize="small">
        BTFDCA is in BETA. If you run into any issue please let me know through&nbsp;
        <Link
          color="teal.500"
          _hover={{ textDecoration: "none" }}
          href="https://discord.gg/AcgfRqukQt"
          onClick={() => analyticsInstance.track("DiscordClicked")}
          isExternal
        >
          Discord
        </Link>
        &nbsp;or&nbsp;
        <Link
          color="teal.500"
          _hover={{ textDecoration: "none" }}
          href="https://twitter.com/btfdca_finance"
          onClick={() => analyticsInstance.track("TwitterClicked")}
          isExternal
        >
          Twitter
        </Link>
        &nbsp;or&nbsp;
        <Link
          color="teal.500"
          _hover={{ textDecoration: "none" }}
          href="mailto:contact@btfdca.com?subject=yo BTFDCA&body=<replace this with your message>"
          onClick={() => analyticsInstance.track("EmailClicked")}
          isExternal
        >
          Email
        </Link>
        .
      </Text>
      <Text fontSize="2xs">Thank you for your support.</Text>
    </Box>
  );
};

const Announcement = () => {
  return (
    <Box p="0.75em" bgColor="#d80621" color="#280000" fontWeight="bold" align="center">
      <Text fontSize="medium">ATTN: the system is paused</Text>
      <Text fontSize="medium">
        There's an issue with the smart contracts, related to how they interact with Superfluid.
      </Text>
      <Text fontSize="medium"> Sorry for that.</Text>
    </Box>
  );
};

const Hero = () => {
  const { chain } = useNetwork();

  const [sourceToken, setSourceToken] = useState();
  const [targetToken, setTargetToken] = useState();
  const [length, setLength] = useState(0); // 0 == FOREVER
  const [amount, setAmount] = useState(parseEther("10"));
  const [dcaConfigErrors, setDcaConfigErrors] = useState({});

  const { isConnected } = useAccount();
  const { isSupportedNetwork } = useSupportedNetwork();

  const childProps = {
    sourceToken,
    setSourceToken,
    targetToken,
    setTargetToken,
    length,
    setLength,
    amount,
    setAmount,
    dcaConfigErrors,
    setDcaConfigErrors,
  };

  return (
    <Box as="section" position="relative" minH="100vh">
      {/* content */}
      <VStack>
        <BetaBanner />

        {/* <Announcement /> */}
        <Box textAlign="center" px="1em">
          <Heading size="xl" color="gold" bg="black" display="inline">
            GM, and welcome to BTFDCA!
          </Heading>
          <Heading size="md" color="gold" bg="black" display="block">
            Buy your favorite crypto assets through dollar cost average.
          </Heading>
        </Box>

        <Box
          height="100%"
          gridGap={{ lg: 2 }}
          py="2em"
          display={{ lg: "flex" }}
          maxW={{ base: "75%", md: "fit-content" }}
        >
          <DcaConfig chainId={chain?.id} {...childProps} />

          {sourceToken || targetToken ? (
            <DcaInfo chainId={chain?.id} {...childProps} mt={{ base: "2em", lg: "0" }} />
          ) : (
            <Center
              backgroundColor="pink"
              textColor="black"
              minW={{ sm: "0", md: "35em" }}
              borderRadius="0.25em"
              mt={{ base: "2em", lg: "0" }}
            >
              <Container maxW="md" my={{ base: "2em", lg: "0" }}>
                <Text fontSize="xl" fontWeight="bold">
                  BTFDCA in 5 steps
                </Text>
                <Text>1. Pick an asset to BUY</Text>
                <Text>2. Pick a token to SPEND</Text>
                <Text>3. Set the DURATION of the investment</Text>
                <Text>4. Set the AMOUNT to invest</Text>
                <Text>6. BTFDCA!</Text>

                <Text fontSize="xl" fontWeight="bold" mt="2em">
                  What happens next?
                </Text>
                <Text>1. Every day, BTFDCA will swap your tokens for the asset you specified.</Text>
                <Text>2. The asset is automatically sent to you after the swap.</Text>

                {!(isConnected && isSupportedNetwork) && <WalletNetwork />}
              </Container>
            </Center>
          )}
        </Box>
      </VStack>

      {/* overlay */}
      <Box position="absolute" inset="0" bg="black" opacity="0.3" zIndex="-1" />

      {/* bg image */}
      <Box
        position="absolute"
        bg="#7fc7d9"
        bgImage="url('./bg.jpg')"
        bgPosition="center"
        bgRepeat="no-repeat"
        inset="0"
        zIndex="-2"
      />
    </Box>
  );
};

export default Hero;
